import styled from 'styled-components';

/** Picture-card upload: two tiles per row inside entity form image column */
export const FormImagesUploadWrap = styled.div`
  width: 100%;

  .ant-upload-list.ant-upload-list-picture-card {
    display: grid !important;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    align-items: start;
  }

  /* Square “+” tile */
  .ant-upload-list-picture-card .ant-upload-select {
    width: 100% !important;
    margin-inline: 0 !important;
    margin-bottom: 0 !important;
    aspect-ratio: 1;
    max-width: 100%;
  }

  .ant-upload-list-picture-card .ant-upload-select .ant-upload {
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
  }

  /* Square tile; list item is absolutely filled so preview/delete stay on the card */
  .ant-upload-list-item-container {
    position: relative;
    width: 100% !important;
    max-width: 100%;
    margin-inline: 0 !important;
    margin-bottom: 0 !important;
    aspect-ratio: 1;
    overflow: hidden;
  }

  .ant-upload-list-picture-card
    .ant-upload-list-item-container
    .ant-upload-list-item {
    position: absolute !important;
    inset: 0 !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box;
    overflow: hidden;
  }

  /* Hover dim mask: antd uses ::before; pin it to the full tile */
  .ant-upload-list-picture-card .ant-upload-list-item::before {
    position: absolute !important;
    inset: 0 !important;
    width: 100% !important;
    height: 100% !important;
    left: 0 !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    margin: 0 !important;
    z-index: 1;
  }

  .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
  .ant-upload-list-picture-card .ant-upload-list-item-thumbnail img,
  .ant-upload-list-picture-card .ant-upload-list-item-image,
  .ant-upload-list-picture-card .ant-upload-list-item-image img {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
  }

  .ant-upload-list-picture-card .ant-upload-list-item-thumbnail,
  .ant-upload-list-picture-card .ant-upload-list-item-image {
    position: relative;
    z-index: 0;
  }

  /* Preview/delete: fill card and center icons above the mask */
  .ant-upload-list-picture-card .ant-upload-list-item-actions {
    position: absolute !important;
    inset: 0 !important;
    width: 100% !important;
    height: 100% !important;
    margin: 0 !important;
    z-index: 2;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px;
  }

  .ant-upload-list-picture-card .ant-upload-list-item-action {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .ant-upload-list-picture-card .ant-upload-list-item {
    margin: 0 !important;
  }
`;
